export const Tags = [
    {
        id: 1,
        tags: ["Updates", "New Updates", "New Version"]
    }
]